import PropTypes from 'prop-types';
import { useRef } from 'react';
import { FileUploadTrigger } from '@dextech-ai/dex-design-system';
import FileUpload from '@/dsComponents/fileUpload';

function readText(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (event) => resolve(event.target.result);
		reader.onerror = () => reject(new Error('Failed to read file'));
		reader.readAsText(file);
	});
}

function JsonUpload({ onUpload }) {
	const parsedRef = useRef(null);

	// Parse here so a bad file is rejected with the DS "Invalid File" popup; the parsed value is handed over below.
	async function validateJson(file) {
		let text;
		try {
			text = await readText(file);
		} catch {
			return 'Failed to read file';
		}
		try {
			parsedRef.current = JSON.parse(text);
			return null;
		} catch (err) {
			return 'Invalid JSON file: ' + err.message;
		}
	}

	// The file is not kept (files stays empty), so the same file can be picked again.
	function handleFilesChange(files) {
		if (files.length > 0) {
			onUpload(parsedRef.current);
		}
	}

	return (
		<FileUpload
			files={[]}
			onFilesChange={handleFilesChange}
			accept=".json"
			typeErrorMessage="Only .json files are accepted"
			validate={validateJson}
			dataTestId="json-upload-input"
			className="dsv-json-upload"
		>
			<FileUploadTrigger asChild>
				<button
					type="button"
					className="dsv-btn dsv-btn--ghost"
					title="Upload JSON schema file"
				>
					Upload JSON
				</button>
			</FileUploadTrigger>
		</FileUpload>
	);
}

JsonUpload.propTypes = {
	onUpload: PropTypes.func.isRequired,
};

export default JsonUpload;
